import React, { memo } from 'react';
import { AlertCircle, AlertTriangle } from 'lucide-react';

import { cn } from '~/shadcn/lib/utils';

/**
 * Risk level configuration
 */
const RISK_CONFIG = {
    CRITICAL: {
        label: 'Issue',
        className: 'bg-destructive text-white',
        Icon: AlertCircle,
    },
    AT_RISK: {
        label: 'At Risk',
        className: 'bg-amber-500 text-white',
        Icon: AlertTriangle,
    },
    ON_TRACK: {
        label: 'On Track',
        className: 'bg-green-600 text-white',
        Icon: null,
    },
};

/**
 * RiskBadge - Displays risk level indicator for a route
 *
 * @param {Object} props
 * @param {'CRITICAL' | 'AT_RISK' | 'ON_TRACK'} props.riskLevel
 * @param {string} [props.className] - Additional CSS classes
 */
function RiskBadge({ className, riskLevel }) {
    const config = RISK_CONFIG[riskLevel];

    // Fallback for unknown risk levels
    if (!config) {
        return (
            <span
                className={cn(
                    'inline-flex items-center gap-1 rounded-md px-2 py-0.5 text-xs font-medium',
                    'bg-secondary text-secondary-foreground',
                    className,
                )}
            >
                {riskLevel}
            </span>
        );
    }

    const { className: variantClassName, Icon, label } = config;

    return (
        <span
            className={cn(
                'inline-flex items-center gap-1 rounded-md px-2 py-0.5 text-xs font-medium',
                variantClassName,
                className,
            )}
        >
            {Icon && <Icon className="h-3 w-3" />}
            {label}
        </span>
    );
}

export default memo(RiskBadge);
